import {observer} from 'mobx-react';
import React from 'react';

import {Button} from '@udemy/react-core-components';
import {FooterButtons} from '@udemy/react-dialog-components';
import {Checkbox, FormGroup, TextInput} from '@udemy/react-form-components';

import {CreateModalStore} from 'src/stores/create-modal-store';

import styles from '../create-modal.module.less';

export const ClientNameStep = observer(({store}: {store: CreateModalStore}) => {
    return (
        <>
            <FormGroup label="App or integration name">
                <TextInput
                    required={true}
                    placeholder="App or integration name - (minimum 5 characters)"
                    value={store.form.clientName}
                    onChange={(ev) => store.setClientName(ev.target.value)}
                    data-testid="client-title-input"
                />
            </FormGroup>

            <hr className={styles['divider']} />

            <div className={styles['tos-container']}>
                <Checkbox
                    data-testid="tos-checkbox"
                    checked={store.isToSAccepted}
                    onChange={(ev) => store.setToSAccepted(ev.target.checked)}
                >
                    I agree to the API{' '}
                    <a href="https://www.udemy.com/terms/api/" target="_blank" rel="noreferrer">
                        Terms of service
                    </a>
                </Checkbox>
            </div>

            <FooterButtons>
                <Button udStyle="ghost" onClick={() => store.close()}>
                    Cancel
                </Button>

                <Button
                    data-testid="next-button"
                    disabled={!store.isToSAccepted || store.form.clientName.length < 5}
                    onClick={() => store.toScopeSelection()}
                >
                    Next Step
                </Button>
            </FooterButtons>
        </>
    );
});
